export const ACTIVATE_RLS_DASHBOARD = 'page/RLS_DASHBOARD [activate]';
export const RLS_DASHBOARD_READY = 'page/RLS_DASHBOARD_READY';
